import { ILLUSTO_TEMPLATE_API_HOSTNAME } from "config/envConfig";

import LocalStorage from "../../../utils/LocalStorage";
import APIService from "../index";

const illustoTemplatesApiInstance = APIService({
  baseURL: ILLUSTO_TEMPLATE_API_HOSTNAME,
});

illustoTemplatesApiInstance.interceptors.request.use((config) => {
  if (!config?.skipAuthHeader) {
    config.headers["Authorization"] = LocalStorage.getItem("authToken");
  }

  return config;
});

illustoTemplatesApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    throw error;
  },
);

export default illustoTemplatesApiInstance;
